import {ref,watch,onMounted,onBeforeUnmount,Ref} from 'vue'

// 首页栏目放不下时采用两行；测量原单行尺寸，避免两行生效后反复切换。
export function useHomeNavigationRows(viewport:Ref<HTMLElement|null>,path:()=>string,labels:()=>string[]){
  const twoRows=ref(false)
  let observer:ResizeObserver|undefined,frame=0,disposed=false
  const measure=()=>{
    frame=0
    const host=viewport.value,items=host?.querySelector('.navigation-items') as HTMLElement|null
    if(!host||!items||path()!=='/main/index'||window.innerWidth<=768||!host.clientWidth){twoRows.value=false;return}
    const clone=items.cloneNode(true) as HTMLElement
    clone.style.cssText='position:fixed;left:-100000px;top:0;visibility:hidden;pointer-events:none;display:flex;width:max-content;min-width:0;font-size:16px;gap:'+Math.min(28,Math.max(12,window.innerWidth*.016))+'px'
    Array.from(clone.children).forEach((node:Element)=>{(node as HTMLElement).style.cssText='flex:0 0 auto;padding:0 4px;font-size:16px;white-space:nowrap'})
    host.appendChild(clone)
    const natural=clone.getBoundingClientRect().width
    clone.remove()
    const available=host.parentElement?.clientWidth||host.clientWidth
    const columns=Math.max(1,Math.ceil(items.children.length/2))
    host.style.setProperty('--home-navigation-columns',String(columns))
    host.style.setProperty('--home-navigation-font',available<280?'12px':available<360?'14px':'16px')
    twoRows.value=natural>available*.9+1
  }
  const schedule=()=>{if(!disposed&&!frame)frame=requestAnimationFrame(measure)}
  watch(()=>[path(),...labels()],schedule,{flush:'post'})
  onMounted(()=>{
    if(typeof ResizeObserver!=='undefined'){observer=new ResizeObserver(schedule);if(viewport.value)observer.observe(viewport.value.parentElement||viewport.value)}
    window.addEventListener('resize',schedule,{passive:true});void document.fonts?.ready.then(schedule);schedule()
  })
  onBeforeUnmount(()=>{disposed=true;observer?.disconnect();window.removeEventListener('resize',schedule);if(frame)cancelAnimationFrame(frame)})
  return {twoRows}
}
